import { render, staticRenderFns } from "./classList.vue?vue&type=template&id=80250410&scoped=true"
import script from "./classList.vue?vue&type=script&lang=js"
export * from "./classList.vue?vue&type=script&lang=js"
import style0 from "./classList.vue?vue&type=style&index=0&id=80250410&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80250410",
  null
  
)

export default component.exports